import apiRequest from './client';

export const listCoverageLimits = ({ tirage, group, supervisor, bank } = {}) => {
  const params = new URLSearchParams();
  if (tirage) params.set('tirage', tirage);
  if (group) params.set('group', group);
  else if (supervisor) params.set('supervisor', supervisor);
  else if (bank) params.set('bank', bank);
  return apiRequest(`/coverage-limits/?${params.toString()}`);
};

export const createCoverageLimit = (data) =>
  apiRequest('/coverage-limits/', { method: 'POST', body: data });

export const updateCoverageLimit = (id, data) =>
  apiRequest(`/coverage-limits/${id}/`, { method: 'PATCH', body: data });
